export class UnderwritingApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLoanUnderwritingByLoanId({ loanId }) {
    return this.#http.get(`/loan/${loanId}/Underwriting`);
  }

  async getLoanUnderwritingPurchaseLoansByLoanId({ loanId }) {
    return this.#http.get(`/loan/${loanId}/Underwriting/purchase-loans`);
  }

  async editLoanUnderwritingPurchaseLoans({ loanId, ...body }) {
    return this.#http.put(`/loan/${loanId}/Underwriting/purchase-loans`, body);
  }

  async editLoanUnderwritingExpirationDates({ loanId, withLoanOptionId, ...body }) {
    return this.#http.put(`/loan/${loanId}/Underwriting/expiration-dates`, body, {
      params: { withLoanOptionId },
    });
  }

  async editLoanUnderwritingManualNotes({ loanId, ...body }) {
    return this.#http.put(`/loan/${loanId}/Underwriting/manual-notes`, body);
  }
}
